export const getButtonWidth = (i: number, buttonsCount: number) => {
  if (buttonsCount && buttonsCount <= 2) {
    return '100%';
  }

  if (buttonsCount && buttonsCount === 3) {
    switch (i) {
      case 0: {
        return 'calc(50% - 4px)';
      }
      case 1: {
        return 'calc(50% - 4px)';
      }
      case 2: {
        return '100%';
      }
    }
  }
};
